import { Validatable } from "formstate";

interface FormData {
  [key: string]: any;
}
type FieldNameStatePair = [string, Validatable<any>];

/**
 * Unwraps FormState's fields into an object of type T
 * See https://formstate.github.io/
 * @param $formState  value of FormState instance's $ attr, as returned by FormState.validate().value
 * @typeparam T  Type of returned object
 */
export function unwrapFormState<T extends FormData>(
  $formState: FormData,
  emptyStringToUndefined?: boolean
): T {
  let result = {} as T;
  return Object.entries($formState).reduce((r: T, [fName, fState]: FieldNameStatePair) => {
    r[fName as keyof T] = emptyStringToUndefined
      ? fState.$ !== ""
        ? fState.$
        : undefined
      : fState.$;
    return result;
  }, result);
}
